






import { defineComponent } from '@vue/composition-api';
import { ViewGridIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'NotificationRetrievalQueryIcon',
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
    components: { ViewGridIcon },
});
